import { PlusCircle } from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import { useToast } from "../../../Toaster/ToastContext";
import PropTypes from "prop-types";
import { apiClient } from "../../../services/apiClient";

const imageStyles = {
  imagePreviewContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  previewImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  removeImageBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "rgba(255, 255, 255, 0.8)",
    border: "none",
    borderRadius: "50%",
    width: "25px",
    height: "25px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "18px",
    color: "#dc3545",
    padding: 0,
  },
};

export default function AddAddons({ addons, onSave }) {
  const { showToast } = useToast();
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    image: "",
    status: "active",
  });
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });

  useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions);
      if (getPermissions.permissions) {
        parsedPermissions = getPermissions.permissions;
      } else {
        parsedPermissions = getPermissions;
      }

      const inventoryPermissions = parsedPermissions.find(
        (item) => item.title === "Inventory"
      );

      const productPermissions = inventoryPermissions?.childPage?.find(
        (child) => child.title === "Addons"
      );
      // console.log("search product", productPermissions)

      if (productPermissions) {
        setPermissions({
          create: productPermissions.create || false,
          read: productPermissions.read || false,
          update: productPermissions.update || false,
          delete: productPermissions.delete || false,
        });
      } else {
        console.error("Product permissions not found in localStorage");
        showToast(
          "Product permissions not found.",
          "error",
          "Permissions Error"
        );
      }
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  useEffect(() => {
    if (addons) {
      setFormData({
        id: addons.id,
        name: addons.name || "",
        price: addons.price || "",
        image: addons.image || "",
        status: addons.status || "active",
      });
      setImagePreview(addons.image || null);
    } else {
      setFormData({ name: "", price: "", image: "", status: "active" });
    }
    setErrors({ name: "", price: "", status: "", image: "" });
  }, [addons]);

  const [errors, setErrors] = useState({
    name: "",
    price: "",
    image: "",
    status: "",
  });

  const validateField = (name, value) => {
    switch (name) {
      case "name":
        return value.trim() ? "" : "Name is required";
      case "price":
        return value.trim() ? "" : "Price is required";
      case "image":
        return value || imageFile ? "" : "Image is required";
      case "status":
        return value ? "" : "Status is required";
      default:
        return "";
    }
  };

  const validateForm = () => {
    const newErrors = {
      name: validateField("name", formData.name),
      price: validateField("price", formData.price),
      image: validateField("image", formData.image),
      status: validateField("status", formData.status),
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFormData((prev) => ({ ...prev, image: reader.result }));
        setErrors((prev) => ({ ...prev, image: "" }));
      };
      reader.readAsDataURL(file);
      setImageFile(file);
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setImageFile(null);
    setFormData((prev) => ({ ...prev, image: "" }));
    setErrors((prev) => ({ ...prev, image: "Image is required" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("name", formData.name);
        formDataToSend.append("price", formData.price);
        formDataToSend.append("status", formData.status);

        if (imageFile) {
          formDataToSend.append("image", imageFile);
        } else {
          formDataToSend.append("image", addons.image);
        }

        if (formData.id) {
          formDataToSend.append("id", formData.id);
        }

        const response = await apiClient.post(
          "/storeaddon",
          formDataToSend,
          true
        );
        const Apidata = await response;

        if (Apidata.status) {
          onSave && onSave();
          // Reset form
          setFormData({ name: "", price: "", image: "", status: "active" });
          setImagePreview(null);
          setImageFile(null);
          setErrors({ name: "", price: "", image: "", status: "" });
          document
            .getElementById("add-addons")
            .querySelector('[data-bs-dismiss="modal"]')
            .click();
          // Show toast and call onSave
          showToast(Apidata.message, "success", "Addons Operation!");
        } else {
          showToast(
            Apidata.message || "Failed to save addons",
            "error",
            "Addons Operation!"
          );
        }
      } catch (error) {
        showToast(
          error.message ||
            "An unexpected error occurred: Please contact the support team.",
          "error",
          "Addons Operation!"
        );
      }
    }
  };

  return (
    <>
      <div className="modal fade" id="add-addons">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header d-flex justify-content-between align-items-center">
                  <div className="page-title">
                    <h4>{addons ? "Update Addons" : "Create Addons"}</h4>
                  </div>
                  <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body new-employee-field">
                  <form onSubmit={handleSubmit}>
                    <label className="form-label">Image</label>
                    <div className="profile-pic-upload mb-3">
                      <div className="profile-pic brand-pic"
                        style={{
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minHeight: "120px",
                          border: "1px dashed #ccc",
                          borderRadius: "8px",
                          cursor: "pointer",
                          overflow: "hidden",
                        }}
                      >
                        {imagePreview ? (
                          <div
                            style={{
                              ...imageStyles.imagePreviewContainer,
                              position: "relative",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <img src={imagePreview} alt="Addon" style={imageStyles.previewImage} />
                            <button type="button" style={imageStyles.removeImageBtn}
                              onClick={() => {
                                handleRemoveImage();
                                document.getElementById(
                                  "addons-image-upload"
                                ).value = "";
                              }}
                            >
                              ×
                            </button>

                            <label htmlFor="addons-image-upload"
                              style={{
                                position: "absolute",
                                bottom: "5px",
                                right: "5px",
                                background: "#ff9f43",
                                color: "white",
                                borderRadius: "50%",
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                            >
                              ✎
                            </label>
                          </div>
                        ) : (
                          <label htmlFor="addons-image-upload"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                              height: "100%",
                              cursor: "pointer",
                              color: "#666",
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                          >
                            <PlusCircle
                              className="plus-down-add"
                              size={28}
                              style={{ marginBottom: "6px" }}
                            />
                            Add Image
                          </label>
                        )}
                      </div>

                      <input type="file" accept="image/*" onChange={handleImageUpload} id="addons-image-upload"
                        style={{ display: "none" }}
                      />
                    </div>
                    {errors.image && (
                      <div className="invalid-feedback d-block">
                        {errors.image}
                      </div>
                    )}
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className={`form-control ${ errors.name ? "is-invalid" : "" }`}
                        name="name" value={formData.name} onChange={handleInputChange}
                      />
                      {errors.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Price</label>
                      <input type="number" className={`form-control ${ errors.price ? "is-invalid" : "" } no-spinner`}
                        name="price" value={formData.price} onChange={handleInputChange} onWheel={(e) => e.target.blur()}
                      />
                      {errors.price && (
                        <div className="invalid-feedback">{errors.price}</div>
                      )}
                    </div>

                    <div className="mb-0">
                      <label className="form-label">Status</label>
                      <select className={`form-select ${ errors.status ? "is-invalid" : "" }`}
                        name="status" value={formData.status} onChange={handleInputChange}>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>

                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      {(addons ? permissions.update : permissions.create) && (
                        <button type="submit" className="btn btn-submit">
                          {addons ? "Update Addons" : "Add Addons"}
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

AddAddons.propTypes = {
  addons: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    price: PropTypes.number,
    image: PropTypes.string,
    status: PropTypes.oneOf(["active", "inactive", ""]),
  }),
  onSave: PropTypes.func,
};

AddAddons.defaultProps = {
  addons: null,
};
